import React from 'react';
import Draggable from 'react-draggable';
import { hideMenus } from '../../../actions/MenuActions';
import menuType from '../../../constants/MenuType';
import configuration from '../../../constants/Configuration';
import platformDetection from '../../../components/utils/PlatformDetection';
import previewCommands from '../../utils/PreviewCommands';
import selectionManager from '../../utils/SelectionManager';
import appParameters from '../../../components/utils/AppParameters';
import modeType from '../../../constants/ModeConstants';
import { getTouchPosition } from '../../utils/TransformToolUtils';
import videoUtils from '../../utils/VideoUtils';
import animationManager from '../../utils/AnimationManager';
import mouseUtils from '../../utils/MouseUtils';

export const Background = React.createClass({
    propTypes: {
        shapeModel: React.PropTypes.object
    },
    getInitialState() {
        return {
            startPoint: undefined,
            endPoint: undefined
        };
    },
    onMouseDown (e) {
        if (previewCommands.isPlayMode() == true || animationManager.isAnimationMode())
            return;

        this.clearSelection();

        var touchPoint = getTouchPosition(e);
        var point = {};
        point.x = (touchPoint.x - this.props.scaleProperties.topX) / this.props.scaleProperties.scale;
        point.y = (touchPoint.y - this.props.scaleProperties.topY) / this.props.scaleProperties.scale;

        this.setState({
            startPoint: point
        });
    },
    onMouseMove (e) {
        if (previewCommands.isPlayMode() == true || animationManager.isAnimationMode())
            return;

        var touchPoint = getTouchPosition(e);
        var point = {};
        point.x = (touchPoint.x - this.props.scaleProperties.topX) / this.props.scaleProperties.scale;
        point.y = (touchPoint.y - this.props.scaleProperties.topY) / this.props.scaleProperties.scale;

        this.setState({
            endPoint: point
        });
    },
    onMouseUp () {
        if (previewCommands.isPlayMode() == true || animationManager.isAnimationMode())
            return;

        if (this.state && this.state.startPoint && this.state.endPoint) {
            var selection = {x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y)};
            selectionManager.selectShapesFromArea(selection);
        }

        this.setState({
            startPoint: undefined,
            endPoint: undefined
        });
    },
    getSelection() {
        if (this.state && this.state.startPoint && this.state.endPoint) {
            return {x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y)};

        } else {
            return undefined;
        }
    },
    getImageBoundingBox() {
        var shapeModel = this.props.shapeModel;
        var imageBoundingBox = {x: 0, y: 0, width: configuration.CANVAS_WIDTH, height: configuration.CANVAS_HEIGHT};

        if ((shapeModel.orgWidth > 0 && shapeModel.orgWidth != configuration.CANVAS_WIDTH) || (shapeModel.orgHeight> 0 && shapeModel.orgHeight != configuration.CANVAS_HEIGHT)) {
            var scaleX = configuration.CANVAS_WIDTH / shapeModel.orgWidth;
            var scaleY =  configuration.CANVAS_HEIGHT / shapeModel.orgHeight;

            if (scaleX < scaleY) {
                imageBoundingBox.y = configuration.CANVAS_HEIGHT / 2 - scaleX * shapeModel.orgHeight / 2;
                imageBoundingBox.height = scaleX * shapeModel.orgHeight;
            } else {
                imageBoundingBox.x = configuration.CANVAS_WIDTH / 2 - scaleY * shapeModel.orgWidth / 2;
                imageBoundingBox.width = scaleY * shapeModel.orgWidth;
            }
        }

        return imageBoundingBox;
    },
    getImagePosition() {
        var shapeModel = this.props.shapeModel;
        var hotspot = this.props.shapeModel.hotSpot;
        var boundingBox = this.getImageBoundingBox();
        var position = {};

        if (this.props.showZoomSlides == true || hotspot == undefined || hotspot == '') {
            position.x = boundingBox.x;
            position.y = boundingBox.y;
            position.width = boundingBox.width;
            position.height = boundingBox.height;
        } else {
            var scale;

            if ((shapeModel.orgWidth > 0 && shapeModel.orgWidth != configuration.CANVAS_WIDTH) || (shapeModel.orgHeight> 0 && shapeModel.orgHeight != configuration.CANVAS_HEIGHT)) {
                scale = configuration.CANVAS_WIDTH / hotspot.width;

                position.width = boundingBox.width * scale;
                position.height = boundingBox.height  * scale;

                position.x = - hotspot.x * scale + boundingBox.x * scale;
                position.y = - hotspot.y * scale + boundingBox.y * scale;

            } else {
                scale = configuration.CANVAS_WIDTH / hotspot.width;

                position.width = configuration.CANVAS_WIDTH * scale;
                position.height = position.width * 9 / 16;

                position.x = - hotspot.x * scale;
                position.y = - hotspot.y * scale;
            }
        }

        return position;
    },
    clearSelection() {
        if (animationManager.isAnimationMode())
            return;

        const {dispatch} = this.props;

        selectionManager.checkSelection('');

        mouseUtils.isCanvasAction = true;
        dispatch(hideMenus(menuType.ALL_MENUS));

        if (platformDetection.isTouchableDevice() == true) {
            document.activeElement.blur();
        }
    },
    updateVideo() {
        if (!previewCommands.isPlayMode())
            videoUtils.updateVideoSrc(this.props.shapeModel);
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.startPoint != nextState.startPoint || this.state.endPoint != nextState.endPoint || this.props.shapeModel != newProps.shapeModel || this.props.showZoomSlides != newProps.showZoomSlides || this.props.scaleProperties != newProps.scaleProperties)
            return true;
        else
            return false;
    },
    render() {
        const { shapeModel } = this.props;
        const canvasWidth = configuration.CANVAS_WIDTH;
        const canvasHeight = configuration.CANVAS_HEIGHT;
        const position = this.getImagePosition();
        const selection = this.getSelection();
        var fillOpacity = shapeModel.fillOpacity;
        var imageStyle;
        var selectionElement;

        if (selection)
            selectionElement = <rect x={selection.x} y={selection.y} width={selection.width} height={selection.height} fill={'#0000FF'} fillOpacity={0.1} stroke='#0000FF' strokeWidth={1} strokeOpacity={0.3}></rect>;

        if (shapeModel.isVideo) {
            fillOpacity = 0;

            imageStyle = {display: 'none'};
        }

        this.updateVideo();

        var href = videoUtils.checkCacheBreaker(shapeModel.xlinkHref);
        var opacityValue = (shapeModel.opacity >= 0 ? shapeModel.opacity : 1);

        if (appParameters.context == modeType.PRINT) {
            return (
                <g id="background" x="0.00" y="0.00" width={canvasWidth} height={canvasHeight}>
                    <rect x="0.00" y="0.00" width={canvasWidth} height={canvasHeight} fill={shapeModel.fill} fillOpacity={fillOpacity}></rect>
                    <image x={position.x} y={position.y} width={position.width} height={position.height} xlinkHref={href} fillOpacity={fillOpacity} preserveAspectRatio="none" style={imageStyle} opacity={opacityValue}></image>
                    <rect x="0" y="0" width={canvasWidth} height={canvasHeight} fill="none" stroke={shapeModel.stroke} strokeWidth={shapeModel.strokeWidth * 2} strokeOpacity={shapeModel.strokeOpacity}></rect>
                </g>
            );
        } else {
            return (
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                    <g id="background" x="0.00" y="0.00" width={canvasWidth} height={canvasHeight}>
                        <rect x="0.00" y="0.00" width={canvasWidth} height={canvasHeight} fill={shapeModel.fill} fillOpacity={fillOpacity}></rect>
                        <image x={position.x} y={position.y} width={position.width} height={position.height} xlinkHref={href} fillOpacity={fillOpacity} preserveAspectRatio="none" style={imageStyle} opacity={opacityValue}></image>
                        <rect x="0" y="0" width={canvasWidth} height={canvasHeight} fill="none" stroke={shapeModel.stroke} strokeWidth={shapeModel.strokeWidth * 2} strokeOpacity={shapeModel.strokeOpacity}></rect>
                        {selectionElement}
                    </g>
                </Draggable>
            );
        }
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/Background.js
 **/